/**
 * atomberg-faq-search.js
 * ────────────────────────
 * Live client-side filtering for the FAQ page. Matches two possible FAQ
 * markups: the atomberg-faq section's `.atomberg-faq__item` grid (with
 * category pills, self-hidden when no question sets a category), and the
 * live FAQs page's hand-authored `.faq-accordion details` — question text
 * comes from `.atomberg-faq__question-text` or, failing that, the nearest
 * `summary`. Mirrors the search-then-filter idiom already used by
 * atomberg-support-model-search.js.
 */
(function () {
  /** @type {any} */
  var w = window;
  if (w._atombergFaqSearchInit) return;
  w._atombergFaqSearchInit = true;

  var ITEM_SELECTOR = '.atomberg-faq__item, .faq-accordion > details';

  var searchTerm = '';
  var activeCategory = 'all';

  /**
   * @param {HTMLElement} item
   * @returns {string}
   */
  function questionText(item) {
    var questionEl = item.querySelector('.atomberg-faq__question-text, summary');
    return (questionEl ? questionEl.textContent : '') || '';
  }

  /**
   * @param {HTMLElement} item
   * @returns {boolean}
   */
  function matches(item) {
    var matchesSearch = true;
    if (searchTerm) {
      matchesSearch = questionText(item).toLowerCase().indexOf(searchTerm) !== -1;
    }

    var matchesCategory = true;
    if (activeCategory !== 'all') {
      matchesCategory = item.getAttribute('data-faq-category') === activeCategory;
    }

    return matchesSearch && matchesCategory;
  }

  function applyFilters() {
    var items = /** @type {NodeListOf<HTMLElement>} */ (document.querySelectorAll(ITEM_SELECTOR));
    items.forEach(function (item) {
      item.hidden = !matches(item);
    });

    var isFiltering = searchTerm !== '' || activeCategory !== 'all';
    document.querySelectorAll('.atomberg-faq__grid').forEach(function (grid) {
      grid.classList.toggle('atomberg-faq__grid--filtering', isFiltering);
    });
  }

  function wireSearch() {
    var input = /** @type {HTMLInputElement|null} */ (
      document.querySelector('[data-faq-search-input]')
    );
    if (!input) return;
    var searchInput = input;

    var clearButton = /** @type {HTMLButtonElement|null} */ (
      document.querySelector('[data-faq-search-clear]')
    );

    searchInput.addEventListener('input', function () {
      searchTerm = searchInput.value.trim().toLowerCase();
      if (clearButton) clearButton.hidden = searchInput.value === '';
      applyFilters();
    });

    if (clearButton) {
      var clear = clearButton;
      clear.addEventListener('click', function () {
        searchInput.value = '';
        searchTerm = '';
        clear.hidden = true;
        searchInput.focus();
        applyFilters();
      });
    }
  }

  function wirePills() {
    document.querySelectorAll('[data-faq-pills]').forEach(function (pillsWrapper) {
      pillsWrapper.addEventListener('click', function (event) {
        var target = /** @type {HTMLElement} */ (event.target);
        var pill = target.closest('[data-faq-pill]');
        if (!pill) return;

        pillsWrapper.querySelectorAll('[data-faq-pill]').forEach(function (p) {
          p.classList.remove('atomberg-faq__pill--active');
        });
        pill.classList.add('atomberg-faq__pill--active');

        activeCategory = pill.getAttribute('data-faq-pill') || 'all';
        applyFilters();
      });
    });
  }

  function start() {
    wireSearch();
    wirePills();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
